type WeaverError = Error & {
  response?: {
    data?: unknown;
    status?: number;
  };
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const resolveMessage = (data: unknown) => {
  if (typeof data === 'string') return data;
  if (!isRecord(data)) return 'An unexpected error occurred';
  if (typeof data.error === 'string') return data.error;
  if (Array.isArray(data.errors) && typeof data.errors[0] === 'string') {
    return data.errors[0];
  }
  return 'An unexpected error occurred';
};

export const mapWeaverError = (error: unknown): WeaverError => {
  if (error instanceof Error) return error;

  const mappedError = new Error('An unexpected error occurred') as WeaverError;
  if (!isRecord(error)) return mappedError;

  const data = error.data;
  mappedError.message = resolveMessage(data);
  mappedError.response = {
    data,
    status: typeof error.status === 'number' ? error.status : undefined,
  };
  return mappedError;
};
